import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id DB8EEB5C-3705-4DE7-A770-D63ACE14F1BD
 * name network-strength-2-alert
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/network-strength-2-alert.svg
 * tags
 * - Cellphone / Phone 
 * - Alert / Error 
 */
export const NetworkStrength2AlertIcon = createSvgIcon(<><path d="M21 1L1 21H17V19H13V11.8L19 5.8V9H21M19 11V17H21V11M19 19V21H21V19" /></>, 'NetworkStrength2AlertIcon');
export default NetworkStrength2AlertIcon